// extracted by mini-css-extract-plugin
module.exports = {"buttonWrap":"RichTextPopup_buttonWrap__wpeO1","center":"RichTextPopup_center__lmVQH"};